import { createContext, type ReactNode, useContext } from 'react';

export type ExportMode = 'none' | 'png' | 'pdf';

export interface ExportModeState {
  mode: ExportMode;
  isExporting: boolean;
  isPng: boolean;
  isPdf: boolean;
}

const ExportModeContext = createContext<ExportMode>('none');

export interface ExportModeProviderProps {
  mode: ExportMode;
  children: ReactNode;
}

export function ExportModeProvider({ mode, children }: ExportModeProviderProps) {
  return <ExportModeContext.Provider value={mode}>{children}</ExportModeContext.Provider>;
}

export function useExportMode(): ExportModeState {
  const mode = useContext(ExportModeContext);
  return {
    mode,
    isExporting: mode !== 'none',
    isPng: mode === 'png',
    isPdf: mode === 'pdf',
  };
}
